var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304,103.13a32.48,32.48,0,0,0-4.63,11.22l-6.27.59v12.14l6.27.59A32.53,32.53,0,0,0,304,138.9l-4,4.83,8.58,8.58,4.84-4a32.21,32.21,0,0,0,11.22,4.63l.59,6.27h12.14l.59-6.27a32.29,32.29,0,0,0,11.22-4.63l4.84,4,8.58-8.58-4-4.83a32.53,32.53,0,0,0,4.63-11.23l6.27-.59V114.94l-6.27-.59a32.48,32.48,0,0,0-4.63-11.22l4-4.84L354,89.71l-4.84,4A32.48,32.48,0,0,0,338,89.08l-.59-6.27H325.22l-.59,6.27a32.41,32.41,0,0,0-11.22,4.63l-4.84-4L300,98.29Zm41.24,4a19.71,19.71,0,1,1-27.88,0A19.72,19.72,0,0,1,345.23,107.08Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.24,
    y: 34.23,
    width: 95.58,
    height: 75.46,
    rx: 4.94,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.86,34.23h86.41a4.55,4.55,0,0,1,4.55,4.55v8.61a0,0,0,0,1,0,0H179.24a0,0,0,0,1,0,0V38.86A4.63,4.63,0,0,1,183.86,34.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,41.77a2.88,2.88,0,1,1-2.87-2.87A2.87,2.87,0,0,1,269.75,41.77Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.59,41.77a2.88,2.88,0,1,1-2.88-2.87A2.87,2.87,0,0,1,261.59,41.77Z",
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.55,
    cy: 41.77,
    r: 2.87,
    style: {
      fill: "#fafafa",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.18,
    y: 58.39,
    width: 51.14,
    height: 2.68,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.97,
    y: 64.18,
    width: 36.59,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.84,
    y: 58.39,
    width: 9.35,
    height: 2.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.57,
    y: 58.39,
    width: 10.06,
    height: 2.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.18,
    y: 70.62,
    width: 51.14,
    height: 2.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.84,
    y: 70.62,
    width: 9.35,
    height: 2.68,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.57,
    y: 70.62,
    width: 10.06,
    height: 2.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.18,
    y: 96.12,
    width: 51.14,
    height: 2.68,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.84,
    y: 96.12,
    width: 9.35,
    height: 2.68,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.18,
    y: 77.07,
    width: 51.14,
    height: 2.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.84,
    y: 77.07,
    width: 9.35,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.57,
    y: 77.07,
    width: 10.06,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.57,
    y: 64.29,
    width: 24.31,
    height: 2.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.18,
    y: 82.69,
    width: 36.59,
    height: 2.68,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.77,
    y: 82.8,
    width: 24.31,
    height: 2.68,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.18,
    y: 88.52,
    width: 18.3,
    height: 2.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.3,87.26l-10.83,5.06,10.83,5.06v4.08l-14.47-7V90.2l14.47-7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.27,90.2v4.24l-14.48,7V97.38l10.83-5.06-10.83-5.06V83.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "412.08 80.34 405.02 104.74 408.55 104.74 415.61 80.34 412.08 80.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.36,217.84a18.87,18.87,0,0,0-2.71,6.56l-3.66.34v7.09l3.66.35a18.82,18.82,0,0,0,2.71,6.55L35,241.56l5,5,2.82-2.34a19.06,19.06,0,0,0,6.56,2.71l.34,3.66h7.09l.35-3.66a18.93,18.93,0,0,0,6.55-2.71l2.83,2.34,5-5-2.34-2.83A18.82,18.82,0,0,0,72,232.18l3.66-.35v-7.09L72,224.4a18.87,18.87,0,0,0-2.71-6.56L71.58,215l-5-5-2.83,2.33a18.91,18.91,0,0,0-6.55-2.7L56.84,206H49.75l-.34,3.66a19,19,0,0,0-6.56,2.7L40,210l-5,5Zm24.08,2.31a11.51,11.51,0,1,1-16.28,0A11.52,11.52,0,0,1,61.44,220.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.11,135.32a15.67,15.67,0,0,0-2.25,5.44l-3,.29v5.88l3,.29a15.67,15.67,0,0,0,2.25,5.44L437.17,155l4.16,4.16,2.35-1.94a15.64,15.64,0,0,0,5.44,2.24l.28,3h5.89l.29-3a15.8,15.8,0,0,0,5.44-2.24l2.34,1.94,4.17-4.16-1.94-2.35a15.84,15.84,0,0,0,2.24-5.44l3-.29v-5.88l-3-.29a15.67,15.67,0,0,0-2.25-5.44l1.95-2.35-4.17-4.16L461,130.75a15.8,15.8,0,0,0-5.44-2.24l-.29-3H449.4l-.28,3a15.64,15.64,0,0,0-5.44,2.24l-2.35-1.94L437.17,133Zm20,1.91a9.56,9.56,0,1,1-13.52,0A9.57,9.57,0,0,1,459.11,137.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.76,
    y: 426.47,
    width: 34.85,
    height: 0.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.6,
    y: 429.33,
    width: 9.15,
    height: 0.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.51,
    y: 416.7,
    width: 20.19,
    height: 0.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 418.47,
    width: 45.44,
    height: 0.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.27,
    y: 418.47,
    width: 6.66,
    height: 0.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.59,
    y: 422.91,
    width: 98.56,
    height: 0.26,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.92,349.14H263.17a5.87,5.87,0,0,1-5.86-5.86V80a5.87,5.87,0,0,1,5.86-5.86H443.92A5.87,5.87,0,0,1,449.78,80V343.28A5.87,5.87,0,0,1,443.92,349.14ZM263.17,74.4A5.61,5.61,0,0,0,257.56,80V343.28a5.61,5.61,0,0,0,5.61,5.61H443.92a5.61,5.61,0,0,0,5.61-5.61V80a5.61,5.61,0,0,0-5.61-5.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.49,349.14H54.75a5.87,5.87,0,0,1-5.87-5.86V80a5.87,5.87,0,0,1,5.87-5.86H235.49A5.86,5.86,0,0,1,241.35,80V343.28A5.86,5.86,0,0,1,235.49,349.14ZM54.75,74.4A5.62,5.62,0,0,0,49.13,80V343.28a5.62,5.62,0,0,0,5.62,5.61H235.49a5.61,5.61,0,0,0,5.61-5.61V80a5.61,5.61,0,0,0-5.61-5.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 410.21,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.06,447.49c0,3.38-93.52,6.13-208.88,6.13s-208.87-2.75-208.87-6.13,93.51-6.14,208.87-6.14S455.06,444.1,455.06,447.49Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.53,
    y: 402.19,
    width: 7.64,
    height: 7.64,
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.51,121h23.63a0,0,0,0,1,0,0V353.54a0,0,0,0,1,0,0H92.72a7.32,7.32,0,0,1-7.32-7.32V130.12A9.11,9.11,0,0,1,94.51,121Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.62 349.53 205.22 402.82 220.31 402.82 232.35 349.97 215.62 349.53",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.53,
    y: 402.19,
    width: 7.64,
    height: 7.64,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.38 409.83 213.46 409.83 227.23 329.07 291.73 329.07 310.38 409.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.38 409.83 213.46 409.83 227.23 329.07 291.73 329.07 310.38 409.83",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.35 353.54 223.02 353.54 220.31 369.45 299.51 362.91 297.35 353.54",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.03,
    y: 402.19,
    width: 125.63,
    height: 7.64,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 198.03,
    y: 402.19,
    width: 125.63,
    height: 7.64,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.23,121H415.47a8.11,8.11,0,0,1,8,8.17V345.37a8.11,8.11,0,0,1-8,8.17H101.23a8.11,8.11,0,0,1-8-8.17V129.18A8.11,8.11,0,0,1,101.23,121Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.23,121H415.47a8.11,8.11,0,0,1,8,8.17V345.37a8.11,8.11,0,0,1-8,8.17H101.23a8.11,8.11,0,0,1-8-8.17V129.18A8.11,8.11,0,0,1,101.23,121Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 129.01,
    width: 314.18,
    height: 208.46,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 129.01,
    width: 314.18,
    height: 208.46,
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.55,
    y: 129.01,
    width: 314.18,
    height: 16.73,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.55,137.38a3.56,3.56,0,1,1-3.56-3.55A3.56,3.56,0,0,1,410.55,137.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,137.38a3.56,3.56,0,1,1-3.55-3.55A3.56,3.56,0,0,1,400.44,137.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.34,137.38a3.56,3.56,0,1,1-3.56-3.55A3.56,3.56,0,0,1,390.34,137.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,267.82a14.73,14.73,0,0,0-2.08,5.05l-2.82.26v5.46l2.82.27a14.76,14.76,0,0,0,2.08,5l-1.8,2.18,3.86,3.86,2.18-1.8a14.68,14.68,0,0,0,5,2.08l.27,2.82h5.46l.26-2.82a14.73,14.73,0,0,0,5.05-2.08l2.17,1.8,3.86-3.86-1.8-2.18a14.51,14.51,0,0,0,2.09-5l2.81-.27v-5.46l-2.81-.26a14.56,14.56,0,0,0-2.09-5.05l1.8-2.17-3.86-3.86-2.17,1.8a14.56,14.56,0,0,0-5.05-2.09l-.26-2.81h-5.46l-.27,2.81a14.51,14.51,0,0,0-5,2.09l-2.18-1.8L157,265.65Zm17.3,3a7.1,7.1,0,1,1-10,0A7.1,7.1,0,0,1,176.1,270.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,267.82a14.73,14.73,0,0,0-2.08,5.05l-2.82.26v5.46l2.82.27a14.76,14.76,0,0,0,2.08,5l-1.8,2.18,3.86,3.86,2.18-1.8a14.68,14.68,0,0,0,5,2.08l.27,2.82h5.46l.26-2.82a14.73,14.73,0,0,0,5.05-2.08l2.17,1.8,3.86-3.86-1.8-2.18a14.51,14.51,0,0,0,2.09-5l2.81-.27v-5.46l-2.81-.26a14.56,14.56,0,0,0-2.09-5.05l1.8-2.17-3.86-3.86-2.17,1.8a14.56,14.56,0,0,0-5.05-2.09l-.26-2.81h-5.46l-.27,2.81a14.51,14.51,0,0,0-5,2.09l-2.18-1.8L157,265.65Zm17.3,3a7.1,7.1,0,1,1-10,0A7.1,7.1,0,0,1,176.1,270.84Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.92,201a13.54,13.54,0,0,0-1.93,4.68l-2.61.24V211l2.61.24a13.54,13.54,0,0,0,1.93,4.68l-1.67,2,3.58,3.58,2-1.67a13.54,13.54,0,0,0,4.68,1.93l.24,2.61h5.06l.24-2.61a13.54,13.54,0,0,0,4.68-1.93l2,1.67,3.58-3.58-1.67-2a13.54,13.54,0,0,0,1.93-4.68l2.61-.24V206l-2.61-.24a13.54,13.54,0,0,0-1.93-4.68l1.67-2-3.58-3.58-2,1.67a13.54,13.54,0,0,0-4.68-1.93l-.24-2.61h-5.06l-.24,2.61a13.54,13.54,0,0,0-4.68,1.93l-2-1.67L318.25,199Zm16,2.8a6.58,6.58,0,1,1-9.3,0A6.57,6.57,0,0,1,335.94,203.83Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.92,201a13.54,13.54,0,0,0-1.93,4.68l-2.61.24V211l2.61.24a13.54,13.54,0,0,0,1.93,4.68l-1.67,2,3.58,3.58,2-1.67a13.54,13.54,0,0,0,4.68,1.93l.24,2.61h5.06l.24-2.61a13.54,13.54,0,0,0,4.68-1.93l2,1.67,3.58-3.58-1.67-2a13.54,13.54,0,0,0,1.93-4.68l2.61-.24V206l-2.61-.24a13.54,13.54,0,0,0-1.93-4.68l1.67-2-3.58-3.58-2,1.67a13.54,13.54,0,0,0-4.68-1.93l-.24-2.61h-5.06l-.24,2.61a13.54,13.54,0,0,0-4.68,1.93l-2-1.67L318.25,199Zm16,2.8a6.58,6.58,0,1,1-9.3,0A6.57,6.57,0,0,1,335.94,203.83Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.66,173.05a8.87,8.87,0,0,0-1.24,3l-1.69.15v3.27l1.69.16a8.74,8.74,0,0,0,1.24,3l-1.08,1.3,2.31,2.31,1.31-1.08a8.57,8.57,0,0,0,3,1.25l.16,1.69h3.26l.16-1.69a8.57,8.57,0,0,0,3-1.25l1.3,1.08,2.31-2.31-1.07-1.3a8.74,8.74,0,0,0,1.24-3l1.69-.16v-3.27l-1.69-.16a8.9,8.9,0,0,0-1.24-3l1.07-1.3-2.31-2.31-1.3,1.08a8.76,8.76,0,0,0-3-1.25l-.16-1.68h-3.26l-.16,1.68a8.76,8.76,0,0,0-3,1.25l-1.31-1.08-2.31,2.31ZM324,174.86a4.25,4.25,0,1,1-6,0A4.25,4.25,0,0,1,324,174.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.66,173.05a8.87,8.87,0,0,0-1.24,3l-1.69.15v3.27l1.69.16a8.74,8.74,0,0,0,1.24,3l-1.08,1.3,2.31,2.31,1.31-1.08a8.57,8.57,0,0,0,3,1.25l.16,1.69h3.26l.16-1.69a8.57,8.57,0,0,0,3-1.25l1.3,1.08,2.31-2.31-1.07-1.3a8.74,8.74,0,0,0,1.24-3l1.69-.16v-3.27l-1.69-.16a8.9,8.9,0,0,0-1.24-3l1.07-1.3-2.31-2.31-1.3,1.08a8.76,8.76,0,0,0-3-1.25l-.16-1.68h-3.26l-.16,1.68a8.76,8.76,0,0,0-3,1.25l-1.31-1.08-2.31,2.31ZM324,174.86a4.25,4.25,0,1,1-6,0A4.25,4.25,0,0,1,324,174.86Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,300.57a8.9,8.9,0,0,0-1.24,3l-1.69.16V307l1.69.16a8.82,8.82,0,0,0,1.24,3l-1.07,1.3,2.31,2.31,1.3-1.08a8.57,8.57,0,0,0,3,1.25l.16,1.69H186l.16-1.69a8.57,8.57,0,0,0,3-1.25l1.31,1.08,2.31-2.31-1.08-1.3a8.63,8.63,0,0,0,1.24-3l1.69-.16v-3.27l-1.69-.16a8.7,8.7,0,0,0-1.24-3l1.08-1.3L190.47,297,189.16,298a8.76,8.76,0,0,0-3-1.25l-.16-1.68h-3.26l-.16,1.68a8.76,8.76,0,0,0-3,1.25l-1.3-1.08-2.31,2.31Zm10.36,1.81a4.25,4.25,0,1,1-6,0A4.25,4.25,0,0,1,187.36,302.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,300.57a8.9,8.9,0,0,0-1.24,3l-1.69.16V307l1.69.16a8.82,8.82,0,0,0,1.24,3l-1.07,1.3,2.31,2.31,1.3-1.08a8.57,8.57,0,0,0,3,1.25l.16,1.69H186l.16-1.69a8.57,8.57,0,0,0,3-1.25l1.31,1.08,2.31-2.31-1.08-1.3a8.63,8.63,0,0,0,1.24-3l1.69-.16v-3.27l-1.69-.16a8.7,8.7,0,0,0-1.24-3l1.08-1.3L190.47,297,189.16,298a8.76,8.76,0,0,0-3-1.25l-.16-1.68h-3.26l-.16,1.68a8.76,8.76,0,0,0-3,1.25l-1.3-1.08-2.31,2.31Zm10.36,1.81a4.25,4.25,0,1,1-6,0A4.25,4.25,0,0,1,187.36,302.38Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5,206.29a63,63,0,0,0-9,21.8l-12.18,1.15v23.58L190.5,254a63.14,63.14,0,0,0,9,21.81l-7.78,9.39,16.68,16.68,9.39-7.78a63.14,63.14,0,0,0,21.81,9l1.15,12.18h23.58l1.15-12.18a63,63,0,0,0,21.8-9l9.4,7.78,16.68-16.68-7.78-9.39a63.06,63.06,0,0,0,9-21.81l12.17-1.15V229.24l-12.17-1.15a63.09,63.09,0,0,0-9-21.8l7.78-9.4-16.68-16.67-9.4,7.77a63.09,63.09,0,0,0-21.8-9l-1.15-12.18H240.75L239.6,179a63.14,63.14,0,0,0-21.81,9l-9.39-7.78-16.68,16.68ZM279.62,214a38.3,38.3,0,1,1-54.16,0A38.31,38.31,0,0,1,279.62,214Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.26,244.4h-8.5l-1.63,3.93h-4.34L235,230h4.18l8.19,18.32h-4.45Zm-1.33-3.22-2.91-7-2.9,7Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.4,230.82a6.56,6.56,0,0,1,2.76,9.35,6.24,6.24,0,0,1-2.76,2.31,10.4,10.4,0,0,1-4.23.79h-3.69v5.06h-4.24V230h7.93A10.23,10.23,0,0,1,261.4,230.82ZM259.84,239a3.27,3.27,0,0,0,0-4.71,4.44,4.44,0,0,0-2.9-.83h-3.46v6.36h3.46A4.44,4.44,0,0,0,259.84,239Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.14,230h4.24v18.32h-4.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.79,245.88a.5.5,0,0,1-.5-.45,37.14,37.14,0,0,1,8.57-28.17.5.5,0,1,1,.76.65,36.11,36.11,0,0,0-8.33,27.42.51.51,0,0,1-.45.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.48,253.78a.49.49,0,0,1-.48-.36,38.93,38.93,0,0,1-1-4.24.5.5,0,0,1,1-.18,39.49,39.49,0,0,0,1,4.14.5.5,0,0,1-.34.62A.36.36,0,0,1,219.48,253.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.08,239.36H128.33a.5.5,0,0,1-.5-.5V188.8a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v49.56h42.25a.5.5,0,0,1,.5.5A.51.51,0,0,1,171.08,239.36Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.33,
    cy: 188.8,
    r: 2.56,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.2,
    cy: 278.42,
    r: 2.56,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "389.7 298.4 326.08 298.4 326.08 270.99 317.2 270.99 317.2 269.99 327.08 269.99 327.08 297.4 388.7 297.4 388.7 278.05 389.7 278.05 389.7 298.4",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.99,
    y: 305.39,
    width: 108.89,
    height: 104.44,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.99,
    y: 305.39,
    width: 108.89,
    height: 104.44,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.65,
    y: 305.39,
    width: 74.22,
    height: 104.44,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.36,
    y: 310.73,
    width: 66.8,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.36,
    y: 326.9,
    width: 66.8,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.36,
    y: 343.06,
    width: 66.8,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.36,
    y: 359.23,
    width: 66.8,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.36,
    y: 375.4,
    width: 66.8,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.36,
    y: 391.57,
    width: 66.8,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.88,
    y: 310.73,
    width: 26.89,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.88,
    y: 326.9,
    width: 26.89,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.88,
    y: 343.06,
    width: 26.89,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.88,
    y: 359.23,
    width: 26.89,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.88,
    y: 375.4,
    width: 26.89,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.88,
    y: 391.57,
    width: 26.89,
    height: 12.93,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.33,
    y: 312.41,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.33,
    y: 312.41,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.33,
    y: 312.41,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.33,
    y: 312.41,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.33,
    y: 312.41,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.33,
    y: 328.58,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.33,
    y: 328.58,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.33,
    y: 328.58,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.33,
    y: 328.58,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.33,
    y: 328.58,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.33,
    y: 344.75,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.33,
    y: 344.75,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.33,
    y: 344.75,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.33,
    y: 344.75,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.33,
    y: 344.75,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.33,
    y: 360.92,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.33,
    y: 360.92,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.33,
    y: 360.92,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.33,
    y: 360.92,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.33,
    y: 360.92,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.33,
    y: 377.09,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.33,
    y: 377.09,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.33,
    y: 377.09,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.33,
    y: 377.09,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.33,
    y: 377.09,
    width: 1.56,
    height: 9.56,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.33,
    y: 393.25,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.33,
    y: 393.25,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.33,
    y: 393.25,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.33,
    y: 393.25,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.33,
    y: 393.25,
    width: 1.56,
    height: 9.57,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,317.19a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,406.13,317.19Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.13,317.19a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,416.13,317.19Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.13,317.19a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,426.13,317.19Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,333.36a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,406.13,333.36Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.13,333.36a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,416.13,333.36Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.13,333.36a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,426.13,333.36Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,349.53a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,406.13,349.53Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.13,349.53a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,416.13,349.53Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.13,349.53a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,426.13,349.53Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,365.7a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,406.13,365.7Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.13,365.7a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,416.13,365.7Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.13,365.7a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,426.13,365.7Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,381.87a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,406.13,381.87Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.13,381.87a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,416.13,381.87Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.13,381.87a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,426.13,381.87Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,398a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,406.13,398Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.13,398a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,416.13,398Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.13,398a1.59,1.59,0,1,1-1.59-1.59h0A1.59,1.59,0,0,1,426.13,398Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.99,
    y: 305.39,
    width: 34.66,
    height: 104.44,
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tabs--inject-49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 354.01,
    y: 175.26,
    width: 111.08,
    height: 93.4,
    rx: 4.94,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.01,
    y: 175.26,
    width: 111.08,
    height: 93.4,
    rx: 4.94,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.64,175.26H460.54a4.55,4.55,0,0,1,4.55,4.55v11.74a0,0,0,0,1,0,0H354a0,0,0,0,1,0,0V179.89A4.63,4.63,0,0,1,358.64,175.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.81,184.59a3.56,3.56,0,1,1-3.55-3.55A3.55,3.55,0,0,1,458.81,184.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.71,184.59a3.56,3.56,0,1,1-3.56-3.55A3.56,3.56,0,0,1,448.71,184.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.6,184.59a3.56,3.56,0,1,1-3.55-3.55A3.55,3.55,0,0,1,438.6,184.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 205.16,
    width: 56.97,
    height: 3.32,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.89,
    y: 212.34,
    width: 40.77,
    height: 3.32,
    style: {
      fill: "#263238",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.17,
    y: 205.16,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.84,
    y: 205.16,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 220.31,
    width: 56.97,
    height: 3.32,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.17,
    y: 220.31,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.84,
    y: 220.31,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 251.87,
    width: 56.97,
    height: 3.32,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.17,
    y: 251.87,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 228.29,
    width: 56.97,
    height: 3.32,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.17,
    y: 228.29,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#263238",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.84,
    y: 228.29,
    width: 11.21,
    height: 3.32,
    style: {
      fill: "#263238",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.12,
    y: 212.47,
    width: 27.08,
    height: 3.32,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 235.25,
    width: 40.77,
    height: 3.32,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.24,
    y: 235.38,
    width: 27.08,
    height: 3.32,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 242.46,
    width: 20.38,
    height: 3.32,
    style: {
      fill: "#263238",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 79.65,
    width: 111.08,
    height: 93.4,
    rx: 4.94,
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.7,
    y: 79.65,
    width: 111.08,
    height: 93.4,
    rx: 4.94,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.32,79.65H159.23a4.55,4.55,0,0,1,4.55,4.55V95.94a0,0,0,0,1,0,0H52.7a0,0,0,0,1,0,0V84.28A4.63,4.63,0,0,1,57.32,79.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.5,89A3.56,3.56,0,1,1,154,85.43,3.55,3.55,0,0,1,157.5,89Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.4,89a3.56,3.56,0,1,1-3.56-3.56A3.55,3.55,0,0,1,147.4,89Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.29,89a3.56,3.56,0,1,1-3.55-3.56A3.55,3.55,0,0,1,137.29,89Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.24,131.72c-3.68-4.94-11.23-7.35-16.26-3.78a21,21,0,0,0-41.65,5.81c-4.86-1.11-10.2.06-13.35,5.08-4.1,6.5,1.21,12.95,1.21,12.95l28.5.17V141.5H98.05a.73.73,0,0,1-.53-1.24l4.19-4.38,4.86-5.07a.74.74,0,0,1,1.06,0l4.85,5.07,4.2,4.38a.74.74,0,0,1-.53,1.24H112.5V152l30.34.17C147.16,147.21,146.93,136.66,143.24,131.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.52,412.61s87.12-20.41,91.26-2.27c5.92,25.91-56.94,43.33-90.42,42.27S100.52,412.61,100.52,412.61Z",
    style: {
      fill: "#263238",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.52,412.61s87.12-20.41,91.26-2.27c5.92,25.91-56.94,43.33-90.42,42.27S100.52,412.61,100.52,412.61Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,415.94l-40.92,26,5.46,7.76s-2.87,4.27-8.35-8.83l25.31-16.73s-7.92-.79-7.72-2c.34-2,17.74-5.91,25.68-7.65a.79.79,0,0,1,.54,1.48Z",
    style: {
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.8,439l7.1,11.5a143,143,0,0,1-26.54,2.09,25.36,25.36,0,0,1-8.55-1.55l-2.49-4.56,5.36-10.8Z",
    style: {
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.34 434.44 116.15 445.98 119.41 454.81 140.77 445.21 134.34 434.44",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.13,448.94l1.79,6.35a2.52,2.52,0,0,1,1.76,1.62,8.33,8.33,0,0,1-.32,2.82l4.78,17.51a7.56,7.56,0,0,0,1.67-.66,7.87,7.87,0,0,0,1.39-1.26c1.3-1.49,1.44-3.66,1.49-5.26.08-2.68,1.62-10.53,1.62-10.53a8.73,8.73,0,0,1,2.75-3.84,4,4,0,0,0,1.65-3.06,2.3,2.3,0,0,0-2.88-2l-1.74.21a3,3,0,0,1-.83-4s1-3.81-.57-3.17c-.92.36-4.93,2.16-8.15,3.48l-2.08.85h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.64,463.71a.25.25,0,0,0-.06-.29,2.83,2.83,0,0,0-1.36-.71c-.28,0-.4.39-.13.45a2.58,2.58,0,0,1,1.21.61.21.21,0,0,0,.34,0Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,462.16a.25.25,0,0,0-.06-.29,2.78,2.78,0,0,0-1.36-.7c-.28-.06-.41.38-.13.44a2.58,2.58,0,0,1,1.21.61.21.21,0,0,0,.34-.05Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.3,460.59a.28.28,0,0,0-.06-.3,2.94,2.94,0,0,0-1.37-.7c-.27-.06-.4.38-.12.44a2.56,2.56,0,0,1,1.2.62.21.21,0,0,0,.34-.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.46,448h0l-2.33,1,1.79,6.35a2.52,2.52,0,0,1,1.76,1.62,8.33,8.33,0,0,1-.32,2.82l4.78,17.51a7.56,7.56,0,0,0,1.67-.66c.26-.19.49-.38.71-.57l-7.71-28.17Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.73,461.87a2.94,2.94,0,0,1-.51-.05,8.34,8.34,0,0,1-2.24-1.24l-.2-.13.22-.09a11.18,11.18,0,0,1,1.84-.55,3.63,3.63,0,0,1,1.93.11.82.82,0,0,1,.25,1.56A2.19,2.19,0,0,1,122.73,461.87Zm-2.42-1.35a7.07,7.07,0,0,0,2,1.05,2.07,2.07,0,0,0,1.6-.29.73.73,0,0,0,.36-.65c-.06-.26-.36-.41-.54-.48a3.49,3.49,0,0,0-1.81-.1A9.46,9.46,0,0,0,120.31,460.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.92,460.65l0-.23a8.76,8.76,0,0,1,.11-2.57,2.37,2.37,0,0,1,1.23-1.36.82.82,0,0,1,1.2,1,3.63,3.63,0,0,1-.91,1.71,10.66,10.66,0,0,1-1.42,1.27Zm1.81-4a1,1,0,0,0-.39.08,2.1,2.1,0,0,0-1.09,1.22,7.05,7.05,0,0,0-.11,2.22,9.69,9.69,0,0,0,1.21-1.1,3.55,3.55,0,0,0,.85-1.59.77.77,0,0,0-.13-.71A.46.46,0,0,0,121.73,456.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.51,357.18s3.18,28.32,4,29.84c2.88,5.14,21.93,14,21.93,14l9.71-2,7,5.81-4.59,3.59-5.38-2a50.16,50.16,0,0,1-8.9.78c-5,0-29.21-6.13-33.25-12.88s-5.89-38-5.89-38Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.71,368.31s-7.46-24.87,1.84-31.78,16.69,27.3,16.69,27.3Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.71,368.31s-7.46-24.87,1.84-31.78,16.69,27.3,16.69,27.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,413.81l-.07-33-.92-45.4-19.27-4-17-.75L70.1,339.55l-.45,11.08s2.2,50.86,2.08,52.4c-.15,1.88-5.63,13.67-5.63,13.67C90.48,422.26,127,415.49,126.6,413.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,413.81l-.07-33-.92-45.4-19.27-4-17-.75L70.1,339.55l-.45,11.08s2.2,50.86,2.08,52.4c-.15,1.88-5.63,13.67-5.63,13.67C90.48,422.26,127,415.49,126.6,413.81Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,338s4.73,4.21,7.15-1.23l1.26,1s-.12,4.05-2.42,5.4c.56,2.25,10.16,34.95,11.88,51.43l-2.62,6.69-7-5.51s-3.38-28.27-4.54-52.3a9.78,9.78,0,0,1-6-5.71Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.1 338.58 109.2 341.77 109.87 332.2 108.57 331.92 107.48 338.37 105.54 337.24 105.1 338.58",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,332.57c-.07,0,9.65,11.89,9.65,11.89l3.3-2.52,2.27-1.92.59-.72-12.87-8.94a18.27,18.27,0,0,1-1.9,1.76A5.93,5.93,0,0,0,85.35,332.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.04 332.37 90.74 328.17 103.61 340.22 100.25 339.03 95.34 342.8 86.04 332.37",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.61,340.22c-.28-.55,1-11.49,1-11.49l4.56,3.12c-.24-.05-.4,9-.55,9s-3-3.1-3-3.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.26 366.97 125.26 345.71 130.02 366.06 126.26 366.97",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,370.07c.6-.12,3.63-1.12,3.63-1.12L81.9,350.17,91.17,371l-5.57,2.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.04 332.37 90.74 328.17 103.61 340.22 100.25 339.03 95.34 342.8 86.04 332.37",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.61,340.22c-.28-.55,1-11.49,1-11.49l4.56,3.12c-.24-.05-.4,9-.55,9s-3-3.1-3-3.1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.91 357.8 113.07 368.41 119.36 370.69 123.61 366.98 122.83 356.96 110.91 357.8",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.38,339.3l-2,.48s-.07.13,0,.05-1.09,3.77-1.09,3.77c.32.29,1.39,2.14,1.51,2.11s2.77-.28,2.77-.28l1-2.8Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.38,339.3l-2,.48s-.07.13,0,.05-1.09,3.77-1.09,3.77c.32.29,1.39,2.14,1.51,2.11s2.77-.28,2.77-.28l1-2.8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.41,354.49s4.72,31.44,7.45,34.38c4.61,5,27.46,18.15,27.46,18.15l11.41-4a2.54,2.54,0,0,1,2.33.38l7.8,6-.74.63a1.08,1.08,0,0,1-1.17.14l-1.21-.6,1.35,1.32-.42.37a1.74,1.74,0,0,1-1.57.34l-3.49-.94,3.22,2.15a2.91,2.91,0,0,1-2.64.55l-5.1-1.45a65.1,65.1,0,0,1-10.59,1.51c-6,.37-34.37-9.54-39.66-16.79S66.1,359.19,66.1,359.19Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.31,375.41s-7.07-28.5,2.23-35.41,18.51,29.15,18.51,29.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.31,375.41s-7.07-28.5,2.23-35.41,18.51,29.15,18.51,29.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.18,301.69a2.49,2.49,0,0,0,.21-4.92l-5.51-.55q.39,5.31.79,10.61a5.62,5.62,0,0,0,3.25,0,3.54,3.54,0,0,0,2.28-2.23A2.58,2.58,0,0,0,128.18,301.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.11,322.1,95.26,307.19s0,0,0,.05c0,1.41,0,3-.16,4.74,0,0-1.28-.61-1.28-.59-.51,7.74-3.57,21-3.43,22.1l12.45,6.19,2.27-2.27.44-5C104.28,329.21,105.46,325.53,107.11,322.1Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.33,327.13l-7.49-5.92c-.19,3,1.39,7.75,7.4,10.21A8.77,8.77,0,0,1,105.33,327.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.79,299.8c-2.45,10-3.38,14.85,0,21.41,5.15,9.86,17.74,9.94,23.16.81,4.87-8.21,8.07-23.23-.4-30.06A14.25,14.25,0,0,0,97.79,299.8Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9,286.18c3-5,11-5.81,13.93-1.86.43.59-4.31.73-3.77.7l-2.78,7.91c-.55-.31-1.91,0-3.06,1.64,0,0-1.79,10.88-7.43,13.92C91.26,300.85,91.89,286.2,99.9,286.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.35,306.8a9.71,9.71,0,0,0,2.94,6.87c2.49,2.37,5.37.53,6.06-2.65.61-2.87.06-7.57-3.09-8.73S91.35,303.62,91.35,306.8Z",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.37,308.21c-.31,1,0,2,.63,2.18s1.45-.46,1.77-1.46,0-2-.63-2.19S111.69,307.2,111.37,308.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.25,311.42c-.31,1,0,2,.63,2.18s1.46-.46,1.77-1.46,0-2-.63-2.19S121.57,310.41,121.25,311.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.77,308.73s1.26,4.59,1.83,7.31a1.08,1.08,0,0,1-1,1.31,6,6,0,0,1-2.81-.77Z",
    style: {
      fill: "#a24e3f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.32,302.16a.51.51,0,0,0,.49.09,4,4,0,0,1,3.57.27.51.51,0,0,0,.7-.1.5.5,0,0,0-.11-.69,4.94,4.94,0,0,0-4.51-.4.5.5,0,0,0-.29.63A.5.5,0,0,0,110.32,302.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.5,306.84a.58.58,0,0,0,.26-.13.49.49,0,0,0,0-.69,4.88,4.88,0,0,0-4.15-1.7.51.51,0,0,0-.42.57.49.49,0,0,0,.56.41,3.78,3.78,0,0,1,3.27,1.38A.52.52,0,0,0,126.5,306.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.54,318.63a8.21,8.21,0,0,0,1.1.75.3.3,0,0,0,.37-.08h0a.29.29,0,0,0-.12-.37,7.15,7.15,0,0,1-3.7-5.32.27.27,0,0,0-.28-.24.24.24,0,0,0-.25.22.13.13,0,0,0,0,.06A7.28,7.28,0,0,0,110.54,318.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.15,294.2c-.68-2-3.06-2.84-5.17-3a2.68,2.68,0,0,0,2.37-2.69,4.47,4.47,0,0,0-1.86-3.36,6.92,6.92,0,0,0-6.71-1,1,1,0,0,0,.43-1.19,2.26,2.26,0,0,0-.84-1.07,6.22,6.22,0,0,0-7.75.39,5.12,5.12,0,0,0-6-3.38c-2.39.62-6.89,1.1-7.58,7.21a5,5,0,1,0-5.86,8,2.34,2.34,0,0,0-2.9,1.35,3.35,3.35,0,0,0,.66,3.32,6.16,6.16,0,0,0,3,1.78,5.89,5.89,0,0,0,3.3.1,3.21,3.21,0,0,0,2.23-2.28,2.38,2.38,0,0,0,2.54,1.88,2.77,2.77,0,0,0,2.32-2.28,3.3,3.3,0,0,0-1.28-3.06,3,3,0,0,0,4.59-.9,9.39,9.39,0,0,0,4.3,4.47,4.84,4.84,0,0,0,5.74-1.22,10.1,10.1,0,0,0,2.08,2,3.39,3.39,0,0,0,2.77.5,2.06,2.06,0,0,0,1.45-2.22,5.92,5.92,0,0,0,5.54,1.29A4,4,0,0,0,133.15,294.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.43,411.63H107.27v0c0,1.38,1.55,2.49,3.45,2.48h58.89c1.88,0,3.39-1.13,3.38-2.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.15,414h-33a.94.94,0,0,1-1-.83.8.8,0,0,1,.05-.26l14.7-33.68a2.88,2.88,0,0,1,2.73-1.63h33a.93.93,0,0,1,1,.82.66.66,0,0,1-.06.27l-14.69,33.69A2.9,2.9,0,0,1,170.15,414Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.63,377.59h-33a2.88,2.88,0,0,0-2.73,1.63l-14.14,32.41H107.27v0c0,1.38,1.55,2.49,3.45,2.48h58.89a4.23,4.23,0,0,0,1.63-.33,2.61,2.61,0,0,0,1.65-1.43l14.69-33.69a.66.66,0,0,0,.06-.27A.93.93,0,0,0,186.63,377.59Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.78,395.53c-.72,1.61-2.16,2.72-3.24,2.5s-1.37-1.7-.67-3.32,2.15-2.71,3.23-2.48S167.5,393.87,166.78,395.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.85,379.22l-14.14,32.41h1.53l15.34-34A2.88,2.88,0,0,0,150.85,379.22Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "152.55 449 173.83 452.42 177.24 443.65 154.88 436.67 152.55 449",
    style: {
      fill: "#b97964"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.29,456.85l2.87-5.94a2.49,2.49,0,0,1-.24-2.38c.32-.72,2.11-1.9,2.11-1.9l8-16.28a7.16,7.16,0,0,0-1.69-.61,8.38,8.38,0,0,0-1.88,0c-1.95.27-3.49,1.79-4.59,3-1.84,2-8.2,6.81-8.2,6.81a8.71,8.71,0,0,1-4.61,1.05,3.94,3.94,0,0,0-3.26,1.2,2.29,2.29,0,0,0,.81,3.42l1.45,1a3,3,0,0,1-2,3.55s-3.3,2.18-1.67,2.75c.92.34,5.12,1.66,8.4,2.8l2.13.74h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,436.83a.25.25,0,0,0-.16.26,3,3,0,0,0,.56,1.43c.17.23.56,0,.39-.25a2.51,2.51,0,0,1-.5-1.26.2.2,0,0,0-.29-.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.67,437.75a.25.25,0,0,0-.15.26,2.84,2.84,0,0,0,.55,1.43c.17.23.56,0,.39-.25a2.49,2.49,0,0,1-.49-1.26.22.22,0,0,0-.29-.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4,438.74a.25.25,0,0,0-.15.26,2.85,2.85,0,0,0,.56,1.43c.16.22.55,0,.38-.25a2.62,2.62,0,0,1-.49-1.26.21.21,0,0,0-.29-.18Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.92,448.53c.32-.72,2.11-1.9,2.11-1.9l8-16.28a7.16,7.16,0,0,0-1.69-.61c-.32,0-.62,0-.91,0l-12.9,26.2.36.12h0l2.38.83,2.87-5.94A2.49,2.49,0,0,1,185.92,448.53Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.69,439.18l-.22-.08.05-.12-.05.11a10.45,10.45,0,0,1-1.74-.79,3.6,3.6,0,0,1-1.37-1.37,1,1,0,0,1-.09-1,.93.93,0,0,1,.94-.37,2.33,2.33,0,0,1,1.57.94,8.67,8.67,0,0,1,.86,2.41Zm-2.62-3.34a.68.68,0,0,0-.59.26.77.77,0,0,0,.1.71,3.41,3.41,0,0,0,1.28,1.28,9.51,9.51,0,0,0,1.48.69,7.18,7.18,0,0,0-.76-2.09,2.07,2.07,0,0,0-1.4-.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.62,441.28a2.31,2.31,0,0,1-.64-.1,1,1,0,0,1-.7-.73,1,1,0,0,1,.48-.84,3.71,3.71,0,0,1,1.81-.68,11.21,11.21,0,0,1,1.92,0l.24,0-.15.18A8.31,8.31,0,0,1,178.8,441,2.57,2.57,0,0,1,177.62,441.28Zm1.81-2.14a7.81,7.81,0,0,0-.83,0,3.46,3.46,0,0,0-1.69.63.81.81,0,0,0-.38.61.72.72,0,0,0,.53.52,2.15,2.15,0,0,0,1.63-.19,7.11,7.11,0,0,0,1.55-1.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.61,439.3c-4.59-7.31-15-27.12,6.08-31s91.36,29.55,91.36,29.55L165.6,451.3,100.15,441s9,11.95-1.91,11.41C82.44,450.83,78.65,447.05,72.61,439.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.7,441.35l-18-5.65s15.06,9.21,20.59,10.31Z",
    style: {
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,270.84H71.6a6,6,0,0,1,6,6v19.76a6,6,0,0,1-6,6H62.84l-.06,6-6.59-6H35a6,6,0,0,1-6-6V276.83A6,6,0,0,1,35,270.84Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.79,283.59,43,286.28l5.77,2.7v2.17l-7.71-3.74v-2.25l7.71-3.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.35,285.16v2.25l-7.71,3.74V289l5.77-2.7-5.77-2.69v-2.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.07 279.9 51.31 292.9 53.19 292.9 56.95 279.9 55.07 279.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.15,269.49H44.36a.25.25,0,0,1,0-.5H63.15a.25.25,0,0,1,0,.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.34,269.5h-3a.25.25,0,0,1,0-.5h3a.25.25,0,1,1,0,.5Z",
    style: {
      fill: "#BA68C8"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgram);
export default __webpack_public_path__ + "static/media/program.b4a4e6c9874d99948880ff9f31567296.svg";
export { ForwardRef as ReactComponent };